import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const SeikyuMeisaiSortKbn = props => {
  return <Dropdown.Static kubunKey='seikyu_meisai_sort_kbn' {...props} />
}
